import React, { useState, useContext } from 'react';
import { Link, Redirect } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../App/Context/auth';
import { getBaseUrlSolicitante, ensureProtocol } from '../../config/backend';
import { fetchMinhasEmpresasSolicitante, setContextoEmpresaSolicitante } from '../../api/empresas';
import { iniciarGestaoToken } from '../tokenManager';

import './login.css';

function LoginSolicitante() {

    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);

    const [sucesso, setSucesso] = useState('');
    const [mensagemErro, setMensagemErro] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [empresasDisponiveis, setEmpresasDisponiveis] = useState([]);
    const [aguardandoSelecaoEmpresa, setAguardandoSelecaoEmpresa] = useState(false);
    const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
    const { setLogado } = useContext(AuthContext);

    const handleFetchData = async (e) => {
        e.preventDefault();
        const baseUrl = getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
        setMensagemErro('');
        if (!baseUrl) {
            setMensagemErro('Backend não configurado. Configure REACT_APP_BACKEND_SOLICITANTE no .env.local (ex.: localhost:3001) e reinicie o servidor (npm start).');
            setSucesso('N');
            setCarregando(false);
            return;
        }
        setCarregando(true);
        try {
            let response2 = { data: {} };
            try {
                response2 = await axios.post(baseUrl + '/api/token', { user, password }, { timeout: 15000 });
            } catch (err) {
                if (err.response?.status === 403 && err.response?.data?.error === 'sem_vinculo_ativo') {
                    setMensagemErro(err.response?.data?.message || 'Você não possui vínculo ativo em nenhuma empresa. Entre em contato com o administrador do sistema.');
                    setSucesso('N');
                    setCarregando(false);
                    return;
                }
                if (err.response?.status === 401) {
                    setMensagemErro(err.response?.data?.message || 'Credenciais inválidas.');
                    setSucesso('N');
                    setCarregando(false);
                    return;
                }
                try {
                    response2 = await axios.post(baseUrl + '/token', { user, password }, { timeout: 15000 });
                } catch (err2) {
                    if (err2.response?.status === 403 && err2.response?.data?.error === 'sem_vinculo_ativo') {
                        setMensagemErro(err2.response?.data?.message || 'Você não possui vínculo ativo em nenhuma empresa. Entre em contato com o administrador do sistema.');
                        setSucesso('N');
                        setCarregando(false);
                        return;
                    }
                    throw err2.response?.data?.message ? err2 : err;
                }
            }

            const data = response2.data;
            const t = data?.token;
            if (!t) {
                setMensagemErro('Resposta do servidor sem token. Tente novamente.');
                setSucesso('N');
                setCarregando(false);
                return;
            }

            localStorage.setItem("logado", "S");
            if (data.id != null) localStorage.setItem("codUsu", data.id);
            localStorage.setItem("nomUsuSat", user);
            localStorage.setItem("tipoSoft", "SOLICITANTE");
            localStorage.setItem("loginSati", user);
            localStorage.setItem("token", t.startsWith('Bearer ') ? t : 'Bearer ' + t);
            if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
            if (data.empresa_id != null) localStorage.setItem("empresa_id", data.empresa_id);
            if (data.empresa_nome != null) localStorage.setItem("empresa_nome", data.empresa_nome);
            if (data.isSoftbridge != null) localStorage.setItem("isSoftbridge", data.isSoftbridge ? "S" : "N");
            if (data.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(data.ia_habilitada));

            let empresas = Array.isArray(data.empresas_ativas) ? data.empresas_ativas : [];
            if (empresas.length === 0) {
                try {
                    empresas = await fetchMinhasEmpresasSolicitante();
                } catch (e) {
                    console.warn('Minhas empresas (Solicitante) não disponível, usando empresa do token.', e);
                }
            }
            if (empresas.length === 0) {
                iniciarGestaoToken();
                setLogado(true);
                setSucesso('S');
            } else if (empresas.length === 1) {
                localStorage.setItem("empresa_id", empresas[0].id);
                localStorage.setItem("empresa_nome", empresas[0].nome || '');
                if (empresas[0].ia_habilitada != null) localStorage.setItem("ia_habilitada", String(empresas[0].ia_habilitada));
                iniciarGestaoToken();
                setLogado(true);
                setSucesso('S');
            } else {
                setEmpresasDisponiveis(empresas);
                setEmpresaSelecionada(empresas[0]?.id ?? null);
                setAguardandoSelecaoEmpresa(true);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response?.status === 403 && error.response?.data?.error === 'sem_vinculo_ativo') {
                setMensagemErro(error.response?.data?.message || 'Você não possui vínculo ativo em nenhuma empresa. Entre em contato com o administrador do sistema.');
            } else if (error.response?.status === 404 || error.response?.status === 400 || error.response?.status === 401) {
                setMensagemErro(error.response?.data?.message || error.response?.data?.error || 'Usuário ou senha inválidos.');
            } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                setMensagemErro('O servidor demorou demais para responder. Verifique se o Tacoma Backend Solicitante está em execução e tente novamente.');
            } else if (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error')) {
                setMensagemErro('Não foi possível conectar ao servidor. Verifique se o Tacoma Backend Solicitante está em execução (ex.: npm start na pasta do backend na porta 3001).');
            } else {
                setMensagemErro(error.response?.data?.message || 'Erro ao conectar. Tente novamente.');
            }
            localStorage.setItem("logado", "N");
            localStorage.setItem("codUsu", 0);
            setLogado(false);
            setSucesso('N');
        } finally {
            setCarregando(false);
        }
    };

    const confirmarEmpresa = async () => {
        const emp = empresasDisponiveis.find((e) => e.id === empresaSelecionada);
        if (!emp) return;
        setCarregando(true);
        setMensagemErro('');
        try {
            const data = await setContextoEmpresaSolicitante(emp.id);
            if (data?.token) {
                localStorage.setItem("token", data.token.startsWith('Bearer ') ? data.token : 'Bearer ' + data.token);
                if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
            }
            if (data?.empresa_id != null) localStorage.setItem("empresa_id", data.empresa_id);
            if (data?.empresa_nome != null) localStorage.setItem("empresa_nome", data.empresa_nome);
            if (data?.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(data.ia_habilitada));
            iniciarGestaoToken();
            setAguardandoSelecaoEmpresa(false);
            setLogado(true);
            setSucesso('S');
        } catch (err) {
            setMensagemErro(err.response?.data?.message || 'Não foi possível trocar de empresa. Tente novamente.');
        } finally {
            setCarregando(false);
        }
    };

    const Brand = ({ tagline }) => (
        <section className="login-brand">
            <span className="login-orb login-orb--1" aria-hidden="true" />
            <span className="login-orb login-orb--2" aria-hidden="true" />
            <div className="login-brand-inner">
                <Link to="/">
                    <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" className="login-logo" />
                </Link>
                <p className="login-tagline">{tagline}</p>
                <ul className="login-features">
                    <li><i className="fas fa-bolt" /> Abra chamados em segundos</li>
                    <li><i className="fas fa-clock-rotate-left" /> Acompanhe o histórico completo</li>
                    <li><i className="fas fa-shield-halved" /> Acesso seguro e sessão renovada automaticamente</li>
                </ul>
            </div>
        </section>
    );

    if (aguardandoSelecaoEmpresa && empresasDisponiveis.length > 1 && sucesso !== 'S') {
        return (
            <div className="login-page">
                <Brand tagline="Selecione a empresa para continuar" />
                <div className="login-form-wrap">
                    <div className="login-form-card">
                        <h2><i className="fas fa-building" /> Selecionar empresa</h2>
                        <p className="subtitle">Você tem acesso a mais de uma empresa. Escolha com qual deseja trabalhar.</p>
                        <div className="login-field">
                            <label htmlFor="selecao-empresa-sol">Empresa</label>
                            <select
                                id="selecao-empresa-sol"
                                className="login-select-empresa"
                                value={empresaSelecionada ?? ''}
                                onChange={(e) => setEmpresaSelecionada(e.target.value ? Number(e.target.value) : null)}
                            >
                                {empresasDisponiveis.map((emp) => (
                                    <option key={emp.id} value={emp.id}>{emp.nome || `Empresa ${emp.id}`}</option>
                                ))}
                            </select>
                        </div>
                        {mensagemErro && (
                            <div className="login-alert login-alert--error" role="alert"><i className="fas fa-circle-exclamation" /> <strong>{mensagemErro}</strong></div>
                        )}
                        <button type="button" className="login-submit" onClick={confirmarEmpresa} disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Carregando...</> : <>Continuar <i className="fas fa-arrow-right" /></>}
                        </button>
                        <footer className="login-footer">
                            <div className="login-footer-line">
                                <Link to="/">Voltar à escolha de acesso</Link>
                            </div>
                            <div className="login-footer-line">
                                &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <Brand tagline="Central de atendimento e chamados. Entre para abrir e acompanhar seus chamados." />
            <div className="login-form-wrap">
                <div className="login-form-card">
                    <h2><i className="fas fa-user" /> Solicitante</h2>
                    <p className="subtitle">Entre com seu usuário e senha</p>
                    <form onSubmit={handleFetchData}>
                        <div className="login-field">
                            <label htmlFor="floatingInput">Usuário</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-user login-input-icon" />
                                <input
                                    id="floatingInput"
                                    type="text"
                                    value={user}
                                    onChange={(e) => setUser(e.target.value)}
                                    placeholder="Seu usuário"
                                    autoComplete="username"
                                    required
                                    disabled={carregando}
                                />
                            </div>
                        </div>
                        <div className="login-field">
                            <label htmlFor="floatingPassword">Senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="floatingPassword"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Sua senha"
                                    autoComplete="current-password"
                                    required
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-senha"
                                    onClick={() => setMostrarSenha((v) => !v)}
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    tabIndex={-1}
                                >
                                    <i className={mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'} />
                                </button>
                            </div>
                        </div>
                        <button type="submit" className="login-submit" disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Entrando...</> : <>Entrar <i className="fas fa-arrow-right" /></>}
                        </button>
                    </form>
                    {sucesso === 'N' ? (
                        <div className="login-alert login-alert--error" role="alert">
                            <i className="fas fa-circle-exclamation" /> <strong>{mensagemErro || 'Usuário ou senha inválidos.'}</strong>
                        </div>
                    ) : null}
                    {sucesso === 'S' ? (password.trim() !== "alterar123" ? <Redirect to="/Solicitante/home" /> : <Redirect to="/Solicitante/alterarSenha" />) : null}

                    <footer className="login-footer">
                        <div className="login-footer-line">
                            <Link to="/">Voltar à escolha de acesso</Link>
                        </div>
                        <div className="login-footer-line">
                            &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default LoginSolicitante;
